module.exports = __webpack_public_path__ + "static/media/quality-assurance.4db899ae.png";